import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store, { initialState } from '@/store/store'
import jQuery from 'jquery'
import draggable from 'vuedraggable'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import moment from 'moment'
import VeeValidate, { Validator } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
import en from 'vee-validate/dist/locale/en'
import tw from 'vee-validate/dist/locale/zh_TW'
import cn from 'vee-validate/dist/locale/zh_CN'
import i18n from './i18n/index'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VeeValidate, {
  classes: true,
  classNames: {
    invalid: 'is-invalid',
  },
  fastExit: false,
  errorBagName: 'validator',
  useConstraintAttrs: false,
})
Validator.localize({ ja, us: en, 'zh-tw': tw, 'zh-cn': cn })
Validator.localize(store.getters['settings/getLanguage'])

Vue.use(draggable)
moment.locale('ja')
global.moment = moment
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  created() {
    // State初期化
    localStorage.setItem('initialState', JSON.stringify(initialState))
  },
  render: (h) => h(App),
}).$mount('#app')
